import { usePopularCategories } from "src/hooks/usePopularCategories";
import { PopularCategory } from "src/types/graphql.d";
import { Flex } from "@otrium/core";
import { useRouter } from "next/router";
import { CategoryCard } from "src/molecules/CategoryCard";
import { localeFix } from "src/utils/genderLocale/genderLocale";
import { subGenderLocale } from "src/utils/genderLocale/subGenderLocale";

export default function PopularCategories(): JSX.Element {
  const router = useRouter();
  const { slug: genderId, categories } = router.query;

  const popularCategoryGender =
    genderId && localeFix({ gender: genderId as string });

  const popularCategorySubGender =
    categories &&
    categories[0] &&
    subGenderLocale({
      subGender: categories[0],
    });

  const genderOrSubGender = (gdr: string, subGender: string) =>
    gdr === "kids" && subGender ? subGender : gdr;

  const popularCateogryGender = genderOrSubGender(
    popularCategoryGender as string,
    popularCategorySubGender as string
  );

  const { data } = usePopularCategories(popularCateogryGender);

  return (
    <Flex flexWrap="wrap" as="nav">
      {data &&
        data?.popularCategories?.map(
          (category: PopularCategory, index: number) => {
            const size = index < 6 ? "l" : "s";
            const mobileWidth = 1 / 2;
            const desktopWidth = size === "l" ? 1 / 3 : 1 / 4;

            return (
              <Flex
                key={`popular-category-${index}`}
                p={2}
                width={[
                  mobileWidth,
                  mobileWidth,
                  mobileWidth,
                  desktopWidth,
                  desktopWidth,
                  desktopWidth,
                ]}
              >
                <CategoryCard
                  size={size}
                  category={category}
                  link={`/${genderId as string}/${category.slug}`}
                />
              </Flex>
            );
          }
        )}
    </Flex>
  );
}
